<template>
  <div>
    <label class="formulate-input-label" style="margin:0;" for="valueGroup">{{label}}</label>
    <div id="valueGroup" style="display: flex; justify-content: space-between; gap: .5rem;">
      <NxInput
        name="dateInicial"
        type="date"
        placeholder="De:"
        v-model="startDate"
        :value="localInitialValue"
        @update:value="handleInitialValueUpdate"
        :max="getMaxStartDate()"
        :min="getMinStartDate()"
      ></NxInput>
      <NxInput
        name="dateFinal"
        type="date"
        placeholder="Até:"
        v-model="endDate"
        :value="localFinalValue"
        @update:value="handleFinalValueUpdate"
        :max="getMaxEndDate()"
        :min="getMinEndDate()"
      ></NxInput>
    </div>
  </div>
</template>

<script>
import { useReactiveModelMixin } from '../../mixins'

export default {
  name: 'NxInputDateRange',
  mixins: [useReactiveModelMixin('InitialValue'), useReactiveModelMixin('FinalValue')],
  props: {
    label: {
      required: true,
      type: String,
      default: null
    },
    limitToFifteenDays: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      localInitialValue: null,
      localFinalValue: null,
      localInitialMinDate: null,
      localInitialMaxDate: null,
      localFinalMinDate: null,
      localFinalMaxDate: null
    }
  },
  methods: {
    handleInitialValueUpdate (val) {
      this.localInitialValue = val
      this.$emit('update:InitialValue', val) // Emite o evento para o componente pai

      if (val) {
        const minDate = new Date(val)
        const maxDate = new Date(val)
        minDate.setDate(minDate.getDate() - 31) // Permite até 31 dias antes
        maxDate.setDate(maxDate.getDate() + 31) // Permite até 31 dias depois

        this.localFinalMinDate = val // A data final não pode ser anterior à data inicial
        this.localFinalMaxDate = maxDate.toISOString().split('T')[0]

        // Ajusta a data final se estiver fora do intervalo permitido
        if (this.localFinalValue && (this.localFinalValue < this.localFinalMinDate || this.localFinalValue > this.localFinalMaxDate)) {
          this.localFinalValue = null
        }
      }
    },

    handleFinalValueUpdate (val) {
      this.localFinalValue = val
      this.$emit('update:FinalValue', val) // Emite o evento para o componente pai

      if (val) {
        const minDate = new Date(val)
        const maxDate = new Date(val)
        minDate.setDate(minDate.getDate() - 31) // Permite até 31 dias antes
        maxDate.setDate(maxDate.getDate() + 31) // Permite até 31 dias depois

        this.localInitialMinDate = minDate.toISOString().split('T')[0]
        this.localInitialMaxDate = val // A data inicial não pode ser posterior à data final

        // Ajusta a data inicial se estiver fora do intervalo permitido
        if (this.localInitialValue && (this.localInitialValue < this.localInitialMinDate || this.localInitialValue > this.localInitialMaxDate)) {
          this.localInitialValue = null
        }
      }
    },

    getMinStartDate () {
      return this.localInitialMinDate || null
    },

    getMaxStartDate () {
      return this.localInitialMaxDate || this.getCurrentDate()
    },

    getMinEndDate () {
      return this.localFinalMinDate || null
    },

    getMaxEndDate () {
      return this.localFinalMaxDate || this.getCurrentDate()
    },

    getCurrentDate () {
      const today = new Date()
      return today.toISOString().split('T')[0]
    }
  }
}
</script>

<style lang="scss" scoped>
#valueGroup {
  .formulate-input {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-inputs/NxInputDateRangeAtendimento.vue